"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectExportFile = selectExportFile;
const ExportFile_1 = require("../types/ExportFile");
function selectExportFile() {
    return new Promise((resolve, reject) => {
        const input = document.createElement('input');
        input.type = 'file';
        input.accept = '.json';
        input.addEventListener('change', () => {
            const file = input.files?.[0];
            if (file) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        resolve(ExportFile_1.exportFileSchema.parse(JSON.parse(reader.result)));
                    }
                    catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = () => {
                    reject(new Error('Error reading file'));
                };
                reader.readAsText(file);
            }
            else {
                resolve(undefined);
            }
        });
        input.addEventListener('cancel', () => {
            resolve(undefined);
        });
        input.click();
    });
}
